import React from 'react';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Divider } from '../Divider/Divider.es.js';
import { NavContext } from './NavContext.es.js';
import { NavDropdown, NavDropdownTrigger, NavDropdownContent, NavDropdownItem } from './NavDropdown.es.js';
import { NavItem } from './NavItem.es.js';
import { NavLink } from './NavLink.es.js';
import { NavOverflow } from './NavOverflow.es.js';
import { Nav as Nav$1 } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const NavComponent = forwardRef((props, ref) => {
  const _a = props, { children, size = "md", variant = "default", isVertical = false, role, as = "div" } = _a, rest = __objRest(_a, ["children", "size", "variant", "isVertical", "role", "as"]);
  return /* @__PURE__ */ React.createElement(NavContext.Provider, {
    value: { size, variant, isVertical }
  }, /* @__PURE__ */ React.createElement(Nav$1, __spreadValues({
    ref,
    as,
    role,
    variant,
    size,
    isVertical
  }, rest), children));
});
NavComponent.displayName = "Nav";
const Nav = Object.assign(NavComponent, {
  Item: NavItem,
  Link: NavLink,
  Dropdown: NavDropdown,
  DropdownTrigger: NavDropdownTrigger,
  DropdownContent: NavDropdownContent,
  DropdownItem: NavDropdownItem,
  DropdownDivider: Divider,
  Overflow: NavOverflow
});

export { Nav, NavComponent };
//# sourceMappingURL=Nav.es.js.map
